import React from 'react';
import AuthBrand from '@/components/auth/AuthBrand';
import AuthMessage from '@/components/auth/AuthMessage';
import AuthHeroIllus from '@/components/auth/AuthHeroIllus';
import LanguageSelector from '@/components/language/LanguageSelector';

interface AuthGatePanelProps {
  showIllus?: boolean;
}

function AuthGatePanel({ showIllus = true }: AuthGatePanelProps): React.ReactElement {
  return (
    <aside className="auth-shell__story">
      <LanguageSelector id="auth-language" className="language-selector--auth" size="compact" />
      <AuthBrand />
      <div className="auth-shell__story-center">
        <div className="auth-shell__story-body">
          <AuthMessage />
          {showIllus && <AuthHeroIllus />}
        </div>
      </div>
    </aside>
  );
}

export default AuthGatePanel;
